import { EventBus } from './event/bus';
import { NetworkGraph } from './network/graph';
import './style.css';

document.querySelector<HTMLDivElement>('#app')!.innerHTML = `
  <canvas id="beacon-canvas" style="position:fixed;top:0;left:0;width:100vw;height:100vh;"></canvas>
  <div style="position:fixed;bottom:16px;right:16px;z-index:10;font-family:monospace;font-size:11px;color:#aaa;opacity:0.6;pointer-events:none;">
    AgentCred Beacon Visualization v0.1
  </div>
`;

const canvas = document.getElementById('beacon-canvas') as HTMLCanvasElement;
const eventBus = new EventBus();

const graph = new NetworkGraph(canvas, eventBus);

// Start ghost simulation after init
setTimeout(() => {
  eventBus.startGhostSimulation();
}, 500);

// Add real agents on demand for testing
declare global {
  interface Window {
    addAgent: (did: string, authorityId: string) => void;
  }
}

window.addAgent = (did: string, targetAuthority: string) => {
  const agent = graph.addRealAgent({
    did,
    kind: 'real',
    trustScore: 85,
    credentials: ['escrow:full'],
    x: 0,
    y: window.innerHeight / 2,
  });
  const beacon = graph.beacons.find(b => b.def.authorityId === targetAuthority);
  if (beacon) {
    agent.setTarget(beacon);
    beacon.flash(true);
  }
};

console.log('AgentCred Beacon loaded. Call window.addAgent(did, authorityId) to spawn a real agent.');
